"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.markWrappedObservable = exports.toPlainOrThrow = exports.toWrapped = exports.wrap = exports.toObservable = void 0;
const rxjs_1 = require("rxjs");
const domain_1 = require("./domain");
const wrapped = "___wrapped___";
const symbol = Symbol.for(wrapped);
function toObservable(like) {
    if (like instanceof rxjs_1.Observable) {
        return wrap(like);
    }
    else {
        return rxjs_1.of(toWrapped(like));
    }
}
exports.toObservable = toObservable;
function wrap(observable) {
    if (isWrappedObservable(observable)) {
        return observable;
    }
    const result = new rxjs_1.Observable(s => {
        let got = false;
        const subscription = observable.subscribe(value => {
            got = true;
            s.next(toWrapped(value));
        }, error => {
            got = true;
            s.next(domain_1.createRejectedWrapped(error));
        }, () => {
            got = true;
            s.complete();
        });
        if (!got) {
            s.next(domain_1.pendingWrapped);
        }
        s.add(subscription);
    });
    return markWrappedObservable(result);
}
exports.wrap = wrap;
function toWrapped(value) {
    if (domain_1.isWrapped(value)) {
        return value;
    }
    else {
        return domain_1.createFulfilledWrapped(value);
    }
}
exports.toWrapped = toWrapped;
function toPlainOrThrow(value) {
    if (value.status === "fulfilled") {
        return value.value;
    }
    throw new Error("not fulfilled");
}
exports.toPlainOrThrow = toPlainOrThrow;
function isWrappedObservable(observable) {
    return observable[wrapped] === symbol;
}
function markWrappedObservable(observable) {
    ;
    observable[wrapped] = symbol;
    return observable;
}
exports.markWrappedObservable = markWrappedObservable;
